import { IApp } from '@/interfaces/App';

import { ECheckoutStep } from '@/helpers/enums';

export default {
  step: {
    currentStep: ECheckoutStep.authentication,
    totalSteps: 3,
    percentage: 0,
  },
  isPageLoading: false,
  isCardSelectedLoading: false,
  termsOfUse: '',
  termsOfUseLoading: false,
  policy: '',
  policyLoading: false,
  cardSelected: null,
  paymentMethodSelected: null,
  stepFormSelected: null,
  cardFirstDigitsSelected: null,
  isAmountLoading: false,
  customPaymentParamenters: {},
} as IApp;
